import {defineMessage} from 'react-intl'

import type {MessageDescriptor} from 'react-intl'

export enum TopDealsDestination {
  LasVegas = 'LasVegas',
  NewYork = 'NewYork',
  Cancun = 'Cancun',
  NiagaraFalls = 'NiagaraFalls',
  Tokyo = 'Tokyo',
  Dubai = 'Dubai',
  London = 'London',
  Istanbul = 'Istanbul',
  Paris = 'Paris',
  Singapore = 'Singapore',
  Eilat = 'Eilat',
  Jerusalem = 'Jerusalem',
  TelAviv = 'TelAviv',
  DeadSea = 'DeadSea',
  Tiberias = 'Tiberias',
  Athens = 'Athens',
  Budapest = 'Budapest',
  Prague = 'Prague',
  Rome = 'Rome'
}

/**
 * A destination the homepage "Top deals for tonight" widget can list as a
 * chip. `placeId` is the SAPI place id the carousel searches.
 */
export interface TopDealsDestinationDetails {
  name: MessageDescriptor
  placeId: string
}

export const topDealsDestinations: Record<
  TopDealsDestination,
  TopDealsDestinationDetails
> = {
  [TopDealsDestination.LasVegas]: {
    name: defineMessage({id: 'cities.lasVegas', defaultMessage: 'Las Vegas'}),
    placeId: '48989'
  },
  [TopDealsDestination.NewYork]: {
    name: defineMessage({
      id: 'cities.newYork',
      defaultMessage: 'New York City'
    }),
    placeId: '49192'
  },
  [TopDealsDestination.Cancun]: {
    name: defineMessage({id: 'cities.cancun', defaultMessage: 'Cancun'}),
    placeId: '59514'
  },
  [TopDealsDestination.NiagaraFalls]: {
    name: defineMessage({
      id: 'cities.niagaraFalls',
      defaultMessage: 'Niagara Falls'
    }),
    placeId: '31809'
  },
  [TopDealsDestination.Tokyo]: {
    name: defineMessage({id: 'cities.tokyo', defaultMessage: 'Tokyo'}),
    placeId: '254251'
  },
  [TopDealsDestination.Dubai]: {
    name: defineMessage({id: 'cities.dubai', defaultMessage: 'Dubai'}),
    placeId: '24399'
  },
  [TopDealsDestination.London]: {
    name: defineMessage({id: 'cities.london', defaultMessage: 'London'}),
    placeId: '158584'
  },
  [TopDealsDestination.Istanbul]: {
    name: defineMessage({id: 'cities.istanbul', defaultMessage: 'Istanbul'}),
    placeId: '47900'
  },
  [TopDealsDestination.Paris]: {
    name: defineMessage({id: 'cities.paris', defaultMessage: 'Paris'}),
    placeId: '43958'
  },
  [TopDealsDestination.Singapore]: {
    name: defineMessage({id: 'cities.singapore', defaultMessage: 'Singapore'}),
    placeId: '62938'
  },
  [TopDealsDestination.Eilat]: {
    name: defineMessage({id: 'wl.cityEilat', defaultMessage: 'Eilat'}),
    placeId: '143'
  },
  [TopDealsDestination.Jerusalem]: {
    name: defineMessage({id: 'wl.cityJerusalem', defaultMessage: 'Jerusalem'}),
    placeId: '43825'
  },
  [TopDealsDestination.TelAviv]: {
    name: defineMessage({id: 'wl.cityTelAviv', defaultMessage: 'Tel Aviv'}),
    placeId: '49111'
  },
  [TopDealsDestination.DeadSea]: {
    name: defineMessage({id: 'wl.cityDeadSea', defaultMessage: 'Dead Sea'}),
    placeId: '300519'
  },
  [TopDealsDestination.Tiberias]: {
    name: defineMessage({id: 'wl.cityTiberias', defaultMessage: 'Tiberias'}),
    placeId: '60774'
  },
  [TopDealsDestination.Athens]: {
    name: defineMessage({id: 'wl.cityAthens', defaultMessage: 'Athens'}),
    placeId: '69710'
  },
  [TopDealsDestination.Budapest]: {
    name: defineMessage({id: 'wl.cityBudapest', defaultMessage: 'Budapest'}),
    placeId: '47350'
  },
  [TopDealsDestination.Prague]: {
    name: defineMessage({id: 'wl.cityPrague', defaultMessage: 'Prague'}),
    placeId: '34437'
  },
  [TopDealsDestination.Rome]: {
    name: defineMessage({id: 'wl.cityRome', defaultMessage: 'Rome'}),
    placeId: '47182'
  }
}
